import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ReactNode } from 'react';

interface PrivateRouteProps {
    children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    const { user, permissionsLoading, membershipConfirmed, userCompanies, role } = useAuth();

    // Si no hay usuario, redirige a la página de login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Usuario autenticado pero SIN ninguna empresa activa confirmada por el
    // server (lo suspendieron/removieron de todas). Redirige a la pantalla de
    // sin-empresa. Solo cuando membershipConfirmed (online) => no aplica si
    // estamos offline (no se pudo validar) ni mientras cargan los permisos.
    // Los site-admins (role==='admin') quedan exentos: pueden usar herramientas
    // globales sin empresa
    if (
        !permissionsLoading &&
        membershipConfirmed &&
        userCompanies.length === 0 &&
        role !== 'admin'
    ) {
        return <Navigate to="/sin-empresa" replace />;
    }

    // Si hay usuario, renderiza el contenido protegido
    return <>{children}</>;
};

export default PrivateRoute;
